import { useUpdateToDoMutation } from "@/pages/Private/redux/to-do/to-do.api";

import { ToDoInfo, UpdateToDoInfo, UpdateToDoInfoSchema } from "../../../ToDoList/schema/to-do";
import EditModeToDoItem from "./EditModeToDoItem";
import ViewModeToDoItem from "./ViewModeToDoItem";

interface EditableToDoItemProps {
	data: ToDoInfo;
	isEditing: boolean;
	setEditing: (value: number) => void;
	setDeletingToDo: (value: ToDoInfo | null) => void;
	setCopyingToDo: (value: ToDoInfo | null) => void;
}

export default function EditableToDoItem({
	data,
	isEditing,
	setEditing,
	setDeletingToDo,
	setCopyingToDo,
}: EditableToDoItemProps) {
	const [updateToDo, { isLoading }] = useUpdateToDoMutation();

	const handleUpdateToDo = async (values: UpdateToDoInfo) => {
		try {
			await updateToDo(values);
		} catch (error) {
			console.error(error);
		}
	};

	return isEditing ? (
		<EditModeToDoItem
			data={data}
			isLoading={isLoading}
			setEditing={setEditing}
			validationSchema={UpdateToDoInfoSchema}
			onSubmit={handleUpdateToDo}
		/>
	) : (
		<ViewModeToDoItem
			data={data}
			isLoading={isLoading}
			setCopyingToDo={setCopyingToDo}
			setDeletingToDo={setDeletingToDo}
			setIsEditing={setEditing}
		/>
	);
}
